export default {
  PREVIEW: "preview",
  EDITABLE: "editable",
  EDIT: "edit",
};
